<template>
    <div class="table-container">
        <div class="table-operate">
            <el-popover
                v-if="authEdit"
                placement="bottom-end"
                width="300"
                v-model="exportPopoverVisible"
                :offset="-10">
                <div class="export-popover">
                    <p>温馨提示:</p>
                    <p>导入数据前请先导出现有数据及模板;</p>
                    <p>模板结构不可修改、增、删列;</p>
                    <p>新导入的数据会覆盖现有数据;</p>
                    <el-upload style="width: 100%;" action="#" :auto-upload="false" :show-file-list="false" :on-change="handleUpdateFile">
                        <el-button class="btn1" style="background: #4d90dd;margin: 30px 0 6px 0;" @click="exportPopoverVisible = false">我知道了</el-button>
                    </el-upload>
                    <el-button class="btn1" style="background: #000;" @click="handleExportFile">导出数据</el-button>
                </div>
                <div slot="reference" class="btn-bar">
                    <img src="../../assets/images/digital/table-import.png" />
                    <el-button type="text" class="font-color btn">导入数据</el-button>
                </div>
            </el-popover>
            <div class="btn-bar" @click="handleExportFile">
                <img src="../../assets/images/digital/table-export.png" />
                <el-button type="text" class="font-color btn" >导出数据</el-button>
            </div>
        </div>
        <div class="table">
            <el-table
            ref="dataTable"
            class="eltable"
            style="width:100%"
            v-loading="loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            element-loading-spinner="el-icon-loading"
            element-loading-text="数据加载中..."
            :data="listData"
            :height="tableHeight"
            :header-cell-style="renderHeaderStyle"
            :row-style="renderRowStyle"
            @row-click="handleRowClick"
            @sort-change="handleSort"
            @filter-change="handleFilter">
                <el-table-column label="" align="center" fixed="left" width="274">
                    <el-table-column v-for="(item,ind) in tableShowGroupColumn['fixed']" :key="'col-fixed'+ind" :prop="item.field" :label="formatHeaderText(item.name)" sortable="custom" align="center" :width="getColumnWidth(item)">
                    </el-table-column>
                </el-table-column>
                <el-table-column v-for="(key,index) in Object.keys(tableShowGroupColumn['normal'])" :key="'group'+index" :label="key" align="center" :fixed="key==='fixed'">
                    <template v-for="(item,ind) in tableShowGroupColumn['normal'][key]">
                        <el-table-column v-if="item.type==='SELECT'" :key="'col'+key+ind" :prop="item.field" :label="formatHeaderText(item.name)" sortable="custom" :column-key="item.field" align="center" :width="getColumnWidth(item)"
                            :filters="item.values.map(opt => { return {text:opt, value:opt}})"
                            filter-placement="bottom">
                        </el-table-column>
                        <el-table-column v-else :key="'col'+key+ind" :prop="item.field" :label="formatHeaderText(item.name)" sortable="custom" align="center" :width="getColumnWidth(item)">
                        </el-table-column>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-bar">
            <span>每页显示</span>
            <el-select size="small" v-model="query.pageSize" class="select-style" popper-class="select-popper">
                <el-option :value="20" label="20"></el-option>
                <el-option :value="50" label="50"></el-option>
                <el-option :value="80" label="80"></el-option>
            </el-select>
            <span class="count">{{`${(query.page-1)*query.pageSize+1}-${query.page*query.pageSize} / ${total}`}}</span>
            <el-button :class="{'btn':query.page>1,'btn-disable':query.page===1}" :disabled="query.page===1" type="text" @click="onPrev">上一页</el-button>
            <span>/</span>
            <el-button :class="{'btn':query.page<pageMax,'btn-disable':query.page===pageMax}" :disabled="query.page===pageMax" type="text" @click="onNext">下一页</el-button>
            <span style="margin-left: 20px;">前往</span>
            <el-select size="small" v-model="query.page" class="select-style" popper-class="select-popper">
                <el-option v-for="index in pageOptions" :key="'po'+index" :value="index" :label="index"></el-option>
            </el-select>
            <span>页</span>
        </div>
        <!-- <div v-if="selectedRow" style="position: relative;width:300px;height:300px;background:#fff;z-index:11" @click="selectedRow=null"></div> -->
        <DetailEdit v-if="selectedRow" :columnGroupData="tableGroupColumn" :rowData="selectedRow.lotNumber"></DetailEdit>
    </div>
</template>

<script>
import DetailEdit from './DetailEdit.vue'
import { mapState } from 'vuex'

//一级表头颜色值
const TableHeaderLv1Colors = ['#648EB4','#648EB4','#65B8BB','#BBAE65','#92A4B4','#738DC8','#ACBB65','#738DC8','#ACBB65','#738DC8']
//二级表头颜色值
const TableHeaderLv2Colors = ['#4A7296','#4A9396','#A09558','#8394A3','#687FB4','#9CAA5D','#687FB4','#9CAA5D','#687FB4']
export default {
    name: "ReportTable",
    components: { DetailEdit },
    data() {
        return {
            loading: true, //表格加载
            tableColumn: [], //表头数据
            tableFixedColumn: [], //固定列
            exportPopoverVisible: false, //弹出导入数据确认框
            listData:[],
            total: 0,
            query: {
                page: 1,
                pageSize: 50
            },
            pageOptions: [],
            filterValue: {},
            selectedRow: null
        }
    },
    created() {
        this.getColumnAxios()
        this.getDataAxios()

        // setTimeout(()=>{
        //     let filter = document.getElementsByClassName("el-table__column-filter-trigger")[0];
        //     filter.addEventListener('click', () => {
        //         setTimeout(()=>{
        //             console.log(document.getElementsByClassName("el-table-filter__bottom")[0].childNodes[0].innerHTML )
        //             document.getElementsByClassName("el-table-filter__bottom")[0].childNodes[0].innerHTML = '确 定';
        //             document.getElementsByClassName("el-table-filter__bottom")[0].childNodes[1].innerHTML = '取 消';
        //         },500)
        //     }
        //     );
        // },1000)
    },
    computed: {
        ...mapState("gisData",{
            authEdit: state => state.authEdit
        }),
        //表头分类
        tableGroupColumn() {
            let group = {}
            for(let item of this.tableColumn) {
                if(!group[item.grouping]) {
                    let arr = [];
                    arr.push(item);
                    group[item.grouping] = arr;
                }else {
                    group[item.grouping].push(item)
                }
            }
            return group;
        },
        //表头展示分类(解决二级表头不能固定列问题)
        tableShowGroupColumn() {
            let group = {}
            let tableFixedColumn = []
            for(let key in this.tableGroupColumn) {
                group[key] = []
                for(let item of this.tableGroupColumn[key]) {
                    if(item.field === 'lotNumber' || item.field === 'name') {
                        tableFixedColumn.push(item)
                    } else {
                        group[key].push(item)
                    }
                }
            }
            return {'fixed':tableFixedColumn, 'normal': group};
        },
        //表头二级颜色
        tableLv2Color() {
            let colors = {}
            let colSpan = []
            for(let key in this.tableGroupColumn) {
                colSpan.push(this.tableGroupColumn[key].length)
            }
            let count = 0
            for(let i=0; i<colSpan.length; i++) {
                for(let j=0; j<colSpan[i]; j++) {
                    let index = count + j
                    colors[index] = TableHeaderLv2Colors[i]
                }
                count = count + colSpan[i]
            }
            return colors
        },
        pageMax() {
            return Math.ceil(this.total/this.query.pageSize)
        },
        tableHeight() {
            return  (parseInt(window.innerHeight) - 224) + 'px';
        },
    },
    watch: {
        query: {
            handler() {
                this.getDataAxios()
            },
            deep: true
        },
        filterValue: {
            handler() {
                if(this.query.page !== 1) {
                    this.query.page = 1
                } else {
                    this.getDataAxios()
                }
            },
            deep: true
        },
    },
    methods: {
        //获取表头信息
        getColumnAxios() {
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/indicatorSummary/column`
            this.$common.getTokenRequest()
            .get(url)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.tableColumn = data.data;
                }
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/indicatorSummary/column')
            })
        },
        //获取表数据
        getDataAxios() {
            let _this = this;
            _this.loading = true
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/indicatorSummary/list`
            let params = `page=${this.query.page}&size=${this.query.pageSize}`
            if(this.query.sort) {
                params += `&sort=${this.query.sort}`
            }
            for(let key in this.filterValue) {
                params += `&${key}=${this.filterValue[key]}`
            }
            this.$common.getTokenRequest()
            .get(url + '?' + params)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.listData = data.data.list;
                    _this.total = data.data.total;
                    this.pageOptions = []
                    for(let i=0;i<this.pageMax;i++) {
                        this.pageOptions.push(i+1)
                    }
                    // this.$nextTick(()=>{
                    //     this.$refs.dataTable.doLayout();
                    // });
                }
              }
               _this.loading = false
            }).catch(err=>{
                _this.loading = false
                console.log(err,'===/v1/digital/indicatorSummary/list')
            })
        },
        //表头文字换行
        formatHeaderText(text) {
            if(text==='项目名称' || text==='权属单位'|| text==='建设情况' || text==='用地性质' || text==='功能分区') {
                return text;
            }
            if(text.length === 4) {
                return text.slice(0, 2) + '\n' + text.slice(2);
            }
            return text;
        },
        //表格列宽
        getColumnWidth(item) {
            if(item.name === '项目名称') {
                return '200'
            } else if(item.name === '属地') {
                return '90'
            } else if(item.name === '用地性质') {
                return '120'
            }
            return '74'
        },
        //导出数据
        exportFileAxios() {
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/indicatorSummary/export`
            let params = `page=${this.query.page}&size=${this.query.pageSize}`
            if(this.query.sort) {
                params += `&sort=${this.query.sort}`
            }
            for(let key in this.filterValue) {
                params += `&${key}=${this.filterValue[key]}`
            }
            this.$common.getTokenRequest()
            .get(url + '?' + params, {responseType: 'blob'})
            .then(res => {
              if (res.status === 200) {
                const filename = res.headers["content-disposition"];
                this.$common.downloadFileStream(res.data, decodeURIComponent(filename.split("filename=")[1]))
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/indicatorSummary/export')
            })
        },
        //导入数据
        importFileAxios(file) {
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/indicatorSummary/import`
            let data = new FormData();
            data.append("file",file);
            this.$common.getTokenRequest().put(url,data,{
                onUploadProgress: () => {
                    // _this.pre =Math.floor(e.loaded/e.total*100);
                    // e.loaded 已经上传的字节数据，e.total 字节数据  转换为1-100的比例值 赋值个pre	 
                }}
            )
            .then(res=>{
                if(res.data.code===0) {
                    _this.getDataAxios()
                    _this.$message({
                        duration: 3000,
                        message: '导入成功！',
                        type: 'success'
                    });
                }
                // 清空上传进度数据
                // _this.pre = 0;
            }).catch(err=>{
                console.log(err,'===/v1/digital/indicatorSummary/import')
            })
        },
        //表头样式
        renderHeaderStyle({row, column, rowIndex, columnIndex}) {
            let style = {borderRight:'1px solid #000', borderBottom:'1px solid #000'}
            if(row || column){
                // console.log(row)
            }
            if(rowIndex === 0) {
                return Object.assign(style, {backgroundColor: TableHeaderLv1Colors[columnIndex]})
            } else if(rowIndex === 1) {
                return Object.assign(style, {backgroundColor: this.tableLv2Color[columnIndex]})
            }
        },
        //表格行样式
        renderRowStyle({row, rowIndex}) {
            if(row){
                // console.log(row)
            }
            if(rowIndex % 2 === 0) {
                return {backgroundColor: '#071129'}
            } else {
                return {backgroundColor: '#0A1733'}
            }
        },
        //表格排序
        handleSort(value) {
            this.query.page = 1
            const { prop, order } = value;
            if(order) {
                let ordernew = order.replace("ending","")
                this.$set(this.query, 'sort', prop+','+ordernew)
            } else {
                this.$delete(this.query, 'sort')
            }
        },
        //表格筛选
        handleFilter(filters) {
            for(let key in filters) {
                if(filters[key] && filters[key].length > 0) {
                    this.$set(this.filterValue, key, filters[key])
                } else {
                    this.$delete(this.filterValue, key)
                }
            }
        },
        //选中行数据
        handleRowClick(row) {
            this.selectedRow = row
        },
        //导入数据
        handleUpdateFile(file) {
            this.importFileAxios(file.raw)
        },
        //导出数据
        handleExportFile() {
            if(this.exportPopoverVisible) {
                this.exportPopoverVisible = false
            }
            this.exportFileAxios()
        },
        //关闭详情弹窗
        handleCloseEdit(isFresh) {
            //编辑保存后刷新数据
            if(isFresh) {
                this.getDataAxios()
                this.$parent.getListAxios()
            }
            this.selectedRow = null
        },
        //上一页
        onPrev() {
            this.query.page--
        },
        //下一页
        onNext() {
            this.query.page++
        }
    }
}
</script>

<style lang="scss" scoped>
.table-container {
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 10;
    .table-operate {
        position: absolute;
        top: 0;
        right: 10px;
        height: 36px;
        width: 230px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        z-index: 10;
        .btn-bar {
            width: 84px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
                width: 18px;
                height: 18px;
            }
            .btn {
                margin: 0;
                font-size: 14px;
                font-family: SourceHanSansCN-Medium;
                font-weight: 600;
                color: #2899FF;
            }
        }
        .btn:hover, .btn:focus {
            color: #2899FF;
        }
    }
    .table {
        position: absolute;
        width: 100%;
        height: calc(100vh - 223px);
        top: 40px;
        left: 0;
        z-index: 10;
        .eltable {
            position: relative;
            background: transparent;
            border: none;
            font-family: SourceHanSansCN;
            color: #C6C6C6;
            font-size: 12px;
        }
        /deep/ .el-loading-spinner .el-loading-text {
            color: #2899FF;
            font-size: 16px;
        }
        /deep/.el-loading-spinner i {
            color: #2899FF;
            font-size: 30px;
        }
    }
}
.pagination-bar {
    position: absolute;
    z-index: 11;
    width: 100%;
    height: 30px;
    left: 0;
    bottom: 76px;
    background: #273043;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2899FF;
    font-size: 14px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 600;
    .select-style {
        width: 62px;
        height: 30px;
        margin: 0 10px;
        /deep/.el-input__inner {
            width: 100%;
            border: none;
            background-color:transparent;
            font-size: 14px;
            color: #2899FF;
            font-weight: 600;
        }
        /deep/.el-input__suffix {
           color: #2899FF;
           height: 32px;
        }
        // /deep/ .el-icon-arrow-up:before {
        //     content: ' ';
        // }
        /deep/.el-select__caret {
            color: #2899FF;
        }
    }
    .count {
        margin: 0 40px;
    }
    /deep/ .el-button--text {
        color: #2899FF;
    }
    .btn {
        color: #2899FF;
        font-size: 14px;
        font-weight: 600;
        margin: 0 4px;
    }
    .btn:hover,  .btn:focus{
        color: #2899FF;
    }
    .btn-disable {
        font-weight: 600;
        font-size: 14px;
        margin: 0 4px;
        color: #6B7892;
    }
}
.export-popover {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    font-weight: bold;
    p {
        font-size: 16px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 600;
        color: #424242;
        margin: 4px 0;
        &:first-child {
            font-size: 20px;
            margin-bottom: 10px;
        }
    }
    .btn1 {
        width: 100%;
        height: 40px;
        color: #fff;
        font-family: SourceHanSansCN;
        font-size: 18px;
        margin: 0;
    }
}
</style>
<style lang="scss">
.el-table th.gutter {
    display: table-cell!important;
}
/**表格样式 */
.el-table thead, .el-table th {
    color: #fff;
    font-family: SourceHanSansCN-Bold;
}
.el-table th > .cell.highlight {
    color: #000;
}
.el-table--border th, .el-table--border td {
    border-right: 1px solid rgba(235, 238, 245, 0.3);
}
.el-table--border th:first-child .cell, .el-table--border td:first-child .cell {
    padding-left: 4px;
}
.el-table td, .el-table th {
    border-bottom: 1px solid rgba(235, 238, 245, 0.3);
    padding: 2px 0;
}
.el-table th > .cell {
    line-height: 18px;
    height: 40px;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: pre-line;
}
.el-table .cell {
    line-height: 18px;
    padding: 0 6px;
}
.el-table--enable-row-hover .el-table__body tr:hover>td, .el-table__body .el-table__row.hover-row td{
    background-color: #2867A1 !important;
    cursor: pointer;
}
//固定列滚动条样式
.el-table .el-table__fixed {
    height: auto !important;
    bottom: 18px !important;
}
.el-table__fixed-body-wrapper .el-table__body {
    padding-bottom: 18px;
}
.el-table__fixed::before {
    height: 0;
}
// 滚动条的宽度
.el-table__body-wrapper::-webkit-scrollbar {
    width: 0; // 横向滚动条
    height: 18px; // 纵向滚动条
    background-color: transparent;
}
// 滚动条的滑块轨道
.el-table__body-wrapper::-webkit-scrollbar-track-piece {
    background-color: rgba(7, 17, 41, 1);
}
// 滚动条的滑块
.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #6a81b6;
    border-radius: 3px;
}
/**排序箭头 */
.el-table .sort-caret.ascending {
    border-bottom-color: #fff;
}.el-table .sort-caret.descending {
    border-top-color: #fff;
}
.el-table .ascending .sort-caret.ascending {
    border-bottom-color: #232323;
}
.el-table .descending .sort-caret.descending {
    border-top-color: #232323;
}
/**筛选箭头 */
.el-table__column-filter-trigger {
    width: 24px;
    height: 100%;
    display: inline-flex;
    align-items: center;
}
.el-table__column-filter-trigger i {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}
.el-icon-arrow-down:before {
    position: absolute;
    top: -10px;
    left: 4px;
}
.el-upload {
    width: 100%;
}
/**每页显示选择列表弹框 */
.select-popper {
    background: #0b3153;
    border: solid 1px #0b3153;
    .el-select-dropdown__item.selected {
        font-size: 14px;
        color: #2899FF;
    }
    li {
        color: #fff;
        background: transparent;
        font-size: 14px;
        height: 22px;
        line-height: 22px;
    }
    .el-select-dropdown__item:hover,
    .el-select-dropdown__item.hover {
        background-color: transparent;
        margin-right: 1px;
    }
    .popper__arrow::after {
        border-top-color: #0b3153!important;
    }
    .popper__arrow {
        border-top-color: #0b3153!important;
    }
    .el-select-dropdown__empty {
        padding: 20px;
        font-size: 14px;
    }
}
/**筛选弹框 */
.el-table-filter__checkbox-group label.el-checkbox {
    color: #424242;
    font-size: 16px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 600;
}
.el-table-filter {
    .el-checkbox__label {
        font-size: 16px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 600;
        color: #424242;
    }
    .el-checkbox__inner {
        border: 3px solid #424242;
        width: 20px;
        height: 20px;
        border-radius: 4px;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #424242;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #424242;
        border-color: #424242;
        color: #fff;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input .el-checkbox__inner:hover, .el-checkbox__input:hover {
        border-color: #424242;
    }
    .el-checkbox__input .el-checkbox__inner::after {
        border: 2.8px solid #fff;
        box-sizing: content-box;
        content: " ";
        border-left: 0;
        border-top: 0;
        height: 10px;
        left: 3px;
        position: absolute;
        top: -2px;
        width: 5px;
    }
}
.el-table-filter__bottom {
    button {
        width: 106px;
        height: 36px;
        background: #2899FF;
        border-radius: 2px;
        font-size: 17px;
        font-family: SourceHanSansCN;
        font-weight: 400;
        color: #FFFFFF;
    }
    button:last-child {
        background: #232323;
        margin-left: 12px;
    }
    button:hover {
        color: #FFFFFF; 
    }
}
</style>